import React, { useState } from "react";
import { Plus, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const ChipPicker = ({ chips, value, onChange, onChipsChanged }) => {
  const [adding, setAdding] = useState(false);
  const [label, setLabel] = useState("");
  const sel = new Set(value);
  const toggle = (c) => onChange(sel.has(c) ? value.filter((x) => x !== c) : [...value, c]);
  const add = async () => {
    if (!label.trim()) return;
    try {
      await api.post("/teacher/diary/chips", { label });
      onChange([...value, label.trim()]);
      setLabel(""); setAdding(false); onChipsChanged();
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not add chip"); }
  };
  const remove = async (id) => { await api.delete(`/teacher/diary/chips/${id}`); onChipsChanged(); };
  const chip = (c, mine) => (
    <span key={(mine ? "m-" : "b-") + c.label} className={`inline-flex items-center rounded-full border text-sm font-medium transition-colors ${sel.has(c.label) ? "bg-amber-400 border-amber-500 text-amber-950" : mine ? "bg-amber-50 border-amber-300 text-amber-900" : "bg-white border-slate-300 text-slate-700"}`}>
      <button type="button" onClick={() => toggle(c.label)} className="px-3 py-1.5" data-testid={`chip-${c.label}`}>{c.label}</button>
      {mine && <button type="button" onClick={() => remove(c.id)} className="pr-2 text-amber-700 hover:text-red-600" aria-label="Delete chip" data-testid={`chip-del-${c.label}`}><X className="h-3 w-3" /></button>}
    </span>
  );
  return (
    <div className="space-y-2" data-testid="chip-picker">
      <div className="flex flex-wrap gap-1.5">
        {chips.mine.map((c) => chip(c, true))}
        {chips.builtin.map((l) => chip({ label: l }, false))}
        {adding ? (
          <span className="inline-flex items-center gap-1">
            <input autoFocus value={label} onChange={(e) => setLabel(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} maxLength={40}
              placeholder="e.g. Ex 5.2 Q1–10" className="h-8 w-40 rounded-full border border-slate-300 px-3 text-sm" data-testid="new-chip-input" />
            <button type="button" onClick={add} className="h-8 rounded-full bg-emerald-700 px-3 text-xs font-bold text-white" data-testid="new-chip-save">Save</button>
          </span>
        ) : (
          <button type="button" onClick={() => setAdding(true)} className="inline-flex items-center gap-1 rounded-full border border-dashed border-emerald-600 px-3 py-1.5 text-sm font-semibold text-emerald-700" data-testid="add-chip-btn"><Plus className="h-3.5 w-3.5" /> My chip</button>
        )}
      </div>
    </div>
  );
};
